import type { BillingOverview, BillingPlan } from "../../shared/billing";

async function readJson<T>(response: Response) {
  const payload = (await response.json().catch(() => null)) as
    | T
    | { error?: string }
    | null;

  if (!response.ok) {
    throw new Error(
      payload && typeof payload === "object" && "error" in payload && payload.error
        ? payload.error
        : "Something went wrong.",
    );
  }

  return payload as T;
}

export async function fetchBillingStatus() {
  return readJson<BillingOverview>(await fetch("/api/billing"));
}

export async function createCheckoutSession(plan: BillingPlan) {
  return readJson<{ url: string }>(
    await fetch("/api/billing/checkout", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ plan }),
    }),
  );
}

export async function createBillingPortalSession() {
  return readJson<{ url: string }>(
    await fetch("/api/billing/portal", {
      method: "POST",
    }),
  );
}

export const BILLING_PORTAL_PATH = "/api/billing/portal";
